import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { RequestForQuoteStatusEnum } from "@enums/requestForQuoteStatus.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { RequestForQuote } from "@interfaces/models/requestForQuote.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { RequestForQuoteService } from "@services/requestForQuote.service";
import { SupplierService } from "@services/supplier.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "requestForQuotes",
	styleUrls: ["requestForQuotes.css"],
	templateUrl: "requestForQuotes.html"
})
export class RequestForQuotesAdminComponent {
	canExportGrid = false;
	deleteEnabled = false;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "RFQ"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: RequestForQuote[] = [];
	purchaseTypes: any;
	statuses: any;
	suppliers: Supplier[] = [];
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: RequestForQuoteService, private protectedGridService: ProtectedGridService, private supplierService: SupplierService) {
		//this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.title = "RFQs";
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.getSuppliers();
		this.checkGridExportPermissions();
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.statuses = GetPropertiesFromEnum(RequestForQuoteStatusEnum);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("RFQs")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if (result) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.items = res.response.items;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	getSuppliers() {
		this.supplierService.getAll()
			.subscribe(
				(res: any) =>  {
					this.suppliers = res.response.items;
					this.suppliers.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	isEditButtonVisible(e: any) {
		return e.row.data.status === RequestForQuoteStatusEnum.Pending;
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Request For Quotes";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}
}